import { createUseMutationHook } from 'hooks/createUseMutationHook';

export const useExtPersonCreate = createUseMutationHook(
    'ext_person_create',
    () => [],
);
